export const FormLabel = {
  baseStyle: {
    fontSize: 'md',
    fontWeight: 'semibold',
    color: 'blue.800',
    marginBottom: '3',
  },
};
